import { useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Button } from "antd";
import { all_routes } from "../../router/all_routes";
import Table from "../../../core/common/dataTable/index";
import AXIOSCONFIGMETHOD from "../../../Axios/axiosConfigMethod";
import { webServiceUrl } from "../../../core/api_utils/webserviceUrl";
import Loading from "../../../core/common/custom-loading/Loading";
import { SalesGroup, ViewGroupsResponse } from "../../../type/group.types";


const ManageSalesGroup = () => {
  const [loading, setLoading] = useState(false);
  const routes = all_routes;
  const [allGroups, setAllGroup] = useState<SalesGroup[]>([]);
  const [selectedGroup, setSelectedGroup] = useState<any>({})
  const organizationId = localStorage.getItem("organization_id");


  const textRender = (text?: string) => <p className="text-capitalize">{text || "-"}</p>;

  const columns = [
    // {
    //   title: "Group ID",
    //   dataIndex: "group_id",
    //   key: "group_id",
    //   render: (text: any) => <p>{text}</p>,
    //   width: 100,
    // },
    {
      title: "Group Id",
      dataIndex: "group_id",
      key: "group_id",
      render: textRender,
    },
    {
      title: "Group Name",
      dataIndex: "group_name",
      key: "group_name",
      render: textRender,
    },
    {
      title: "Group Description",
      dataIndex: "group_description",
      key: "group_description",
      render: textRender,
    },
    {
      title: "Group Members",
      key: "view_members",
      render: (_: any, record: any) => (
        <Link to={`/view-group-member/${record.group_id}`}>
        <Button
          // type="default"
          onClick={() => {
            // Replace with your API call to view members
            console.log("View members for group", record.group_id);
          }}
          >
          View Members
        </Button>
        </Link>
      ),
    },
    {
      title: "Leads",
      key: "view_leads",
      render: (_: any, record: any) => (
        <Link to={`/lead-list/${record.group_id}`}>
        <Button
          // type="default"
          onClick={() => {
            // Replace with your API call to view members
            console.log("View members for group", record.group_id);
          }}
          >
          View Leads
        </Button>
        </Link>
      ),
    },
    {
      title: "Edit Group",
      key: "edit",
      render: (_: any, record: any) => (
        <Link to={`/edit-group-page/${record.group_id}`}>
        <button
        // type="primary"
        className="btn btn-secondary d-flex align-items-center"
        onClick={() => {
          // Replace with your edit logic
          console.log("Edit group", record.group_id);
        }}
        >
          Edit
        </button>
        </Link>
      ),
    },
  ];

  // const column = [
  //   {
  //     title: "Property Name",
  //     dataIndex: "property_name",
  //     render: (text: string, record: any) => (
  //       <p className="text-capitalize">{text ?? "-"}</p>
  //     ),
  //     sorter: (a: any, b: any) =>
  //       (a.property_name || "").localeCompare(b.property_name || ""),
  //   },
  //   {
  //     title: "Property Id",
  //     dataIndex: "property_id",
  //     render: (text: string, record: any) => (
  //       <p className="text-capitalize">{text ?? "-"}</p>
  //     ),
  //     sorter: (a: any, b: any) =>
  //       (a.property_id || "").localeCompare(b.property_id || ""),
  //     width: 500,
  //   },

  //   {
  //     title: "PinCode",
  //     dataIndex: "pincode",
  //     render: (text: string, record: any) => (
  //       <p className="text-capitalize">{text ?? "-"}</p>
  //     ),
  //     sorter: (a: any, b: any) =>
  //       (a.pincode || "").localeCompare(b.pincode || ""),
  //   },
  //   {
  //     title: "City",
  //     dataIndex: "city",
  //     render: (text: string, record: any) => (
  //       <p className="text-capitalize">{text ?? "-"}</p>
  //     ),
  //     sorter: (a: any, b: any) => (a.city || "").localeCompare(b.city || ""),
  //   },
  //   {
  //     title: "State",
  //     dataIndex: "state",
  //     render: (text: string, record: any) => (
  //       <p className="text-capitalize">{text ?? "-"}</p>
  //     ),
  //     sorter: (a: any, b: any) => (a.state || "").localeCompare(b.state || ""),
  //   },
  //   {
  //     title: "Locality",
  //     dataIndex: "locality",
  //     render: (text: string, record: any) => (
  //       <p className="text-capitalize">{text ?? "-"}</p>
  //     ),
  //     sorter: (a: any, b: any) =>
  //       (a.locality || "").localeCompare(b.locality || ""),
  //   },
  //   {
  //     title: "House Flat Block No",
  //     dataIndex: "house_flat_block_no",
  //     render: (text: string, record: any) => <p className="">{text}</p>,
  //     sorter: (a: any, b: any) =>
  //       (a.house_flat_block_no || "").localeCompare(
  //         b.house_flat_block_no || ""
  //       ),
  //   },
  //   {
  //     title: "Added On",
  //     dataIndex: "added_on",
  //     render: (text: string) => {
  //       if (!text) return "-";

  //       const date = new Date(text);
  //       const day = String(date.getDate()).padStart(2, "0");
  //       const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-indexed
  //       const year = date.getFullYear();

  //       return <p className="text-capitalize">{`${day}-${month}-${year}`}</p>;
  //     },
  //     sorter: (a: any, b: any) => {
  //       const dateA = new Date(a.added_on || 0).getTime();
  //       const dateB = new Date(b.added_on || 0).getTime();
  //       return dateA - dateB;
  //     },
  //   },

  //   {
  //     title: "Total Units",
  //     dataIndex: "total_units",
  //     render: (text: string, record: any) => (
  //       <p className="text-capitalize">{text}</p>
  //     ),
  //     sorter: (a: any, b: any) =>
  //       Number(a.total_units || 0) - Number(b.total_units || 0),
  //   },
  //   {
  //     title: "Vacant Units",
  //     dataIndex: "vacant_units",
  //     render: (text: string, record: any) => (
  //       <p className="text-capitalize">{text}</p>
  //     ),
  //     sorter: (a: any, b: any) =>
  //       Number(a.vacant_units || 0) - Number(b.vacant_units || 0),
  //   },
  //   {
  //     title: "Status",
  //     dataIndex: "status",
  //     render: (text: string, record: any) => {
  //       const status = text?.toLowerCase();

  //       let textColor = "inherit";
  //       let backgroundColor = "transparent";

  //       switch (status) {
  //         case "active":
  //           textColor = "green";
  //           backgroundColor = "#e6f4ea"; // light green bg
  //           break;
  //         case "inactive":
  //           textColor = "red";
  //           backgroundColor = "#fdecea"; // light red bg
  //           break;
  //         case "available":
  //           textColor = "goldenrod";
  //           backgroundColor = "#fff8e1"; // light yellow bg
  //           break;
  //       }

  //       const formattedText = text
  //         ? text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
  //         : "-";

  //       return (
  //         <span
  //           style={{
  //             color: textColor,
  //             backgroundColor,
  //             padding: "4px 8px",
  //             borderRadius: "6px",
  //             display: "inline-block",
  //             minWidth: "80px",
  //             textAlign: "center",
  //             textTransform: "capitalize",
  //           }}
  //         >
  //           {formattedText}
  //         </span>
  //       );
  //     },
  //     sorter: (a: any, b: any) =>
  //       (a.status || "").localeCompare(b.status || ""),
  //   },
  // ];


  const getViewGroup = async () => {
    const payload = {
      organization_id: organizationId,
    };
    try {
      setLoading(true);
      const response = await AXIOSCONFIGMETHOD(
        "post",
        webServiceUrl.VIEW_GROUPS,
        payload
      );
      console.log("getViewGroup data ", response?.data);
      if (response?.success) {
        const result = response?.data;
        setAllGroup(result);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    getViewGroup();
  }, []);


  // View Team-member Api


  // const getViewGroupTeams = async () => {
  //   const payload = {
  //     organization_id: organizationId,
  //   };
  //   try {
  //     setLoading(true);
  //     const response = await AXIOSCONFIGMETHOD(
  //       "post",
  //       webServiceUrl.VIEW_GROUP_TEAMS,
  //       payload
  //     );
  //     console.log("getViewGroupTeams data ", response?.data);
  //     if (response?.success) {
  //       const result = response?.data;
  //       setAllGroup(result);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   getViewGroupTeams();
  // }, []);

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Manage Sales Group </h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={all_routes.leaddashboard}>
                  Dashboard
                  </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Mange Sales Groups
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap "></div>
          </div>

          {/* Performance Indicator list */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Group List </h5>

              <Link
                to="/create-group-page"
                className="btn btn-secondary d-flex align-items-center"
                // data-bs-toggle="modal"
                // // data-bs-target="#createGroupModal"
              >
                <i className="ti ti-circle-plus me-2" />
                Create Group
              </Link>
            </div>
            <div className="card-body p-0">
              {loading ? (
                <Loading />
              ) : (
                <Table
                  dataSource={allGroups}
                  rowKeyId={"Staff_id"}
                  columns={columns}
                  Selection={false}
                />
              )}
            </div>
          </div>
          {/* /Performance Indicator list */}
        </div>

        {/* Create Group Modal */}
        <div
          className="modal fade"
          id="createGroupModal"
          tabIndex={-1}
          aria-labelledby="createGroupModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="createGroupModalLabel">
                  Create New Group
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <div className="modal-body">
                <form>
                  <div className="mb-3">
                    <label className="form-label">Group Name</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter group name"
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Description</label>
                    <textarea
                      className="form-control"
                      rows={3}
                      placeholder="Enter group description"
                    ></textarea>
                  </div>

                  {/* Add Members Input */}
                  <div className="mb-3">
                    <label className="form-label">Add Members</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search and add members..."
                    />
                  </div>

                  {/* Members Table (static structure) */}
                  <div className="mb-3">
                    <table className="table table-sm mb-0 align-middle">
                      <thead className="table-light">
                        <tr>
                          <th style={{ width: "40px" }}>
                            <input type="checkbox" />
                          </th>
                          <th style={{ width: "150px" }}>Employee ID</th>
                          <th>Name</th>
                          <th style={{ width: "150px" }}>Phone Number</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <input type="checkbox" />
                          </td>
                          <td>EMP001</td>
                          <td>John Doe</td>
                          <td>123-456-7890</td>
                        </tr>
                        <tr>
                          <td>
                            <input type="checkbox" />
                          </td>
                          <td>EMP002</td>
                          <td>Jane Smith</td>
                          <td>987-654-3210</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  {/* Selected Members Badges (static example) */}
                  <div className="mt-2 d-flex flex-wrap gap-2">
                    <span className="badge bg-primary d-flex align-items-center">
                      John Doe
                      <button
                        type="button"
                        className="btn-close btn-close-white ms-2"
                        style={{ fontSize: "0.6rem" }}
                      ></button>
                    </span>
                    <span className="badge bg-primary d-flex align-items-center">
                      Jane Smith
                      <button
                        type="button"
                        className="btn-close btn-close-white ms-2"
                        style={{ fontSize: "0.6rem" }}
                      ></button>
                    </span>
                  </div>
                </form>
              </div>

              <div className="modal-footer d-flex gap-2">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  data-bs-dismiss="modal"
                >
                  Create Group
                </button>
              </div>
            </div>
          </div>
        </div>

        {/*Footer*/}
        <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
          <p className="mb-0">
            © {new Date().getFullYear()} Nestfin Technology. All rights
            reserved.
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}
    </>
  );
};

export default ManageSalesGroup;


// import { useEffect, useState } from "react";
// import { Link, useParams } from "react-router-dom";
// import { all_routes } from "../../router/all_routes";
// import Table from "../../../core/common/dataTable/index";
// import AXIOSCONFIGMETHOD from "../../../Axios/axiosConfigMethod";
// import { webServiceUrl } from "../../../core/api_utils/webserviceUrl";
// import Loading from "../../../core/common/custom-loading/Loading";
// import SearchSelect from "../../../core/common/search-select/searchSelect";
// import CommonSelect2 from "../../../core/common/commonSelect2";

// interface Member {
//     employee_id: string;
//     organization_user_id: string;
//     email_id: string;
//     full_name: string;
//     mobile_no: number;
// }

// const ManageSalesGroup = () => {
//   const [loading, setLoading] = useState(false);
//   const routes = all_routes;
//   const [allProperty, setAllProperty] = useState<any>([]);
//   const organizationId = localStorage.getItem("organization_id");
//   const [members, setMembers] = useState<Member[]>([]);
//   const [search, setSearch] = useState<string>("");
//   const [filtered, setFiltered] = useState<Member[]>([]);
//   const [selected, setSelected] = useState<Member[]>([]);
//   const [isFocused, setIsFocused] = useState<boolean>(false);



//   const getAllProperty = async () => {
//     const payload = {
//       organization_id: organizationId,
//     };
//     try {
//       setLoading(true);
//       const response = await AXIOSCONFIGMETHOD(
//         "post",
//         webServiceUrl.GET_ALL_PROPERTY,
//         payload
//       );
//       console.log("property tttttttttt data ", response?.data);
//       if (response?.success) {
//         const result = response?.data;
//         setAllProperty(result);
//       }
//     } catch (error) {
//       console.log(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     getAllProperty();
//   }, []);



// const columns = [
//   {
//     title: "Sr No.",
//     dataIndex: "sr_no",
//     render: (_: any, __: any, index: number) => (
//       <h6 className="fw-medium fs-14 text-dark">{index + 1}</h6>
//     ),
//     sorter: false,
//     width: 80,
//   },

//   {
//     title: "Group Name",
//     dataIndex: "group_name",
//     render: (text: string) => <p className="text-capitalize">{text ?? "-"}</p>,
//     sorter: (a: any, b: any) =>
//       (a.group_name || "").localeCompare(b.group_name || ""),
//   },

//   {
//     title: "Group Description",
//     dataIndex: "group_description",
//     render: (text: string) => <p className="text-capitalize">{text ?? "-"}</p>,
//     sorter: (a: any, b: any) =>
//       (a.group_description || "").localeCompare(b.group_description || ""),
//   },

//   {
//     title: "Group Members",
//     dataIndex: "group_members",
//     render: (_: any, record: any) => (
//       <span
//         onClick={() => record.onViewLeads(record)}
//         style={{
//           color: "#007bff",
//           cursor: "pointer",
//           textDecoration: "underline",
//         }}
//       >
//         View
//       </span>
//     ),
//     sorter: false,
//   },

//   {
//     title: "Group Leads",
//     dataIndex: "group_leads",
//     render: (_: any, record: any) => (
//       <span
//         onClick={() => setSelectedGroup(record)} 
//         style={{
//           color: "#007bff",
//           cursor: "pointer",
//           textDecoration: "underline",
//         }}
//       >
//         View
//       </span>
//     ),
//     sorter: false,
//   },

//   {
//     title: "Action",
//     dataIndex: "action",
//     render: (_: any, record: any) => (
//       <div className="d-flex gap-2">
//         <button className="btn btn-sm" 
//         // onClick={() => record.onEdit(record)}  
         
//         >
//           <i className="ti ti-edit" style={{ fontSize: "15px" }} />
//         </button>

//         <button className="btn btn-sm" 
//         // onClick={() => record.onDelete(record)}
//         >
//           <i className="ti ti-trash" style={{ fontSize: "15px" }} />
//         </button>
//       </div>
//     ),
//     sorter: false,
//   },
// ];



//   const columns = [
//     // {
//     //     title: "Sr No.",
//     //     dataIndex: "SrNo",
//     //     render: (text: string, record: any, index: number) => (
//     //         <h6 className="fw-medium fs-14 text-dark" >{index + 1}</h6>
//     //     ),
//     //     sorter: false,
//     // },
//     // {
//     //     title: "Nestfin ID",
//     //     dataIndex: "nestfinid",
//     //     render: (text: string, record: any,) => (
//     //         <p className="text-capitalize" >{text}</p>
//     //     ),
//     //     sorter: (a: any, b: any) => (a.nestfinid || "").localeCompare(b.nestfinid || ""),
//     // },
//     {
//       title: "Property Name",
//       dataIndex: "property_name",
//       render: (text: string, record: any) => (
//         <p className="text-capitalize">{text ?? "-"}</p>
//       ),
//       sorter: (a: any, b: any) =>
//         (a.property_name || "").localeCompare(b.property_name || ""),
//     },
//     {
//       title: "Property Id",
//       dataIndex: "property_id",
//       render: (text: string, record: any) => (
//         <p className="text-capitalize">{text ?? "-"}</p>
//       ),
//       sorter: (a: any, b: any) =>
//         (a.property_id || "").localeCompare(b.property_id || ""),
//       width: 500,
//     },

//     {
//       title: "PinCode",
//       dataIndex: "pincode",
//       render: (text: string, record: any) => (
//         <p className="text-capitalize">{text ?? "-"}</p>
//       ),
//       sorter: (a: any, b: any) =>
//         (a.pincode || "").localeCompare(b.pincode || ""),
//     },
//     {
//       title: "City",
//       dataIndex: "city",
//       render: (text: string, record: any) => (
//         <p className="text-capitalize">{text ?? "-"}</p>
//       ),
//       sorter: (a: any, b: any) => (a.city || "").localeCompare(b.city || ""),
//     },
//     {
//       title: "State",
//       dataIndex: "state",
//       render: (text: string, record: any) => (
//         <p className="text-capitalize">{text ?? "-"}</p>
//       ),
//       sorter: (a: any, b: any) => (a.state || "").localeCompare(b.state || ""),
//     },
//     {
//       title: "Locality",
//       dataIndex: "locality",
//       render: (text: string, record: any) => (
//         <p className="text-capitalize">{text ?? "-"}</p>
//       ),
//       sorter: (a: any, b: any) =>
//         (a.locality || "").localeCompare(b.locality || ""),
//     },
//     {
//       title: "House Flat Block No",
//       dataIndex: "house_flat_block_no",
//       render: (text: string, record: any) => <p className="">{text}</p>,
//       sorter: (a: any, b: any) =>
//         (a.house_flat_block_no || "").localeCompare(
//           b.house_flat_block_no || ""
//         ),
//     },
//     {
//       title: "Added On",
//       dataIndex: "added_on",
//       render: (text: string) => {
//         if (!text) return "-";

//         const date = new Date(text);
//         const day = String(date.getDate()).padStart(2, "0");
//         const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-indexed
//         const year = date.getFullYear();

//         return <p className="text-capitalize">{`${day}-${month}-${year}`}</p>;
//       },
//       sorter: (a: any, b: any) => {
//         const dateA = new Date(a.added_on || 0).getTime();
//         const dateB = new Date(b.added_on || 0).getTime();
//         return dateA - dateB;
//       },
//     },

//     {
//       title: "Total Units",
//       dataIndex: "total_units",
//       render: (text: string, record: any) => (
//         <p className="text-capitalize">{text}</p>
//       ),
//       sorter: (a: any, b: any) =>
//         Number(a.total_units || 0) - Number(b.total_units || 0),
//     },
//     {
//       title: "Vacant Units",
//       dataIndex: "vacant_units",
//       render: (text: string, record: any) => (
//         <p className="text-capitalize">{text}</p>
//       ),
//       sorter: (a: any, b: any) =>
//         Number(a.vacant_units || 0) - Number(b.vacant_units || 0),
//     },
//     {
//       title: "Status",
//       dataIndex: "status",
//       render: (text: string, record: any) => {
//         const status = text?.toLowerCase();

//         let textColor = "inherit";
//         let backgroundColor = "transparent";

//         switch (status) {
//           case "active":
//             textColor = "green";
//             backgroundColor = "#e6f4ea"; // light green bg
//             break;
//           case "inactive":
//             textColor = "red";
//             backgroundColor = "#fdecea"; // light red bg
//             break;
//           case "available":
//             textColor = "goldenrod";
//             backgroundColor = "#fff8e1"; // light yellow bg
//             break;
//         }

//         const formattedText = text
//           ? text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
//           : "-";

//         return (
//           <span
//             style={{
//               color: textColor,
//               backgroundColor,
//               padding: "4px 8px",
//               borderRadius: "6px",
//               display: "inline-block",
//               minWidth: "80px",
//               textAlign: "center",
//               textTransform: "capitalize",
//             }}
//           >
//             {formattedText}
//           </span>
//         );
//       },
//       sorter: (a: any, b: any) =>
//         (a.status || "").localeCompare(b.status || ""),
//     },
//   ];


// //   get sales team
//   const SalesTeamData = async () => {
//     const payload = {
//       "organization_id": organizationId
//     }
//     try {
//       setLoading(true)
//       console.log("Api CAll");
      
//       const response = await AXIOSCONFIGMETHOD("post", webServiceUrl.SALES_TEAM, payload)
//       console.log(response?.data, "anajanjsdfasdfasdfasdfa vk")
//          setMembers(response?.data || []);
//       setFiltered(response?.data || []);
//     } catch (error) {
//       console.log(error)
//     }
//     setLoading(false)
//   }


//   useEffect(() => {
//     SalesTeamData()
//   }, [])


//   useEffect(() => {
//     // Mock employee data — replace with your JSON or API data
//     // setMembers(employees);
//     // setFiltered(employees);
//   }, []);




//   useEffect(() => {
//     const lower = search.toLowerCase();
//     setFiltered(
//       members.filter((m) => m.full_name.toLowerCase().includes(lower))
//     );
//   }, [search, members]);

//   const handleSelect = (member: Member) => {
//     if (!selected.some((s) => s.employee_id === member.employee_id)) {
//       setSelected([...selected, member]);
//     }
//     setSearch("");
//   };

//   const handleRemove = (employee_id: string) => {
//     setSelected(selected.filter((m) => m.employee_id !== employee_id));
//   };

//   const handleSearchChange = (e: any) => {
//     setSearch(e.target.value);
//   };

//   const handleFocus = (e: any) => {
//     setIsFocused(true);
//     setFiltered(members); 
//   };

// const handleCheckboxSelect = (member: Member) => {
//   const isAlreadySelected = selected.some(
//     (s) => s.employee_id === member.employee_id
//   );

//   if (isAlreadySelected) {
//     setSelected(selected.filter((s) => s.employee_id !== member.employee_id));
//   } else {
//     setSelected([...selected, member]);
//   }
// };

// const handleSelectAll = (e: React.ChangeEvent<HTMLInputElement>) => {
//   if (e.target.checked) {
//     // Add all currently filtered members
//     const allFilteredIds = filtered.map((m) => m.employee_id);
//     const newSelected = [
//       ...selected,
//       ...filtered.filter(
//         (m) => !selected.some((s) => s.employee_id === m.employee_id)
//       ),
//     ];
//     setSelected(newSelected);
//   } else {
//     // Remove all filtered members from selected
//     const remaining = selected.filter(
//       (s) => !filtered.some((m) => m.employee_id === s.employee_id)
//     );
//     setSelected(remaining);
//   }
// };


//   const handleBlur = () => {
//     // Delay hiding so clicks can register
//     setTimeout(() => setIsFocused(false), 150);
//   };


//   return (
//     <>
//       {/* Page Wrapper */}
//       <div className="page-wrapper">
//         <div className="content">
//           {/* Breadcrumb */}
//           <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
//             <div className="my-auto mb-2">
//               <h2 className="mb-1">Manage Sales Group </h2>
//               <nav>
//                 <ol className="breadcrumb mb-0">
//                   <li className="breadcrumb-item">
//                     <Link to={all_routes.adminDashboard}>
//                       <i className="ti ti-smart-home" />
//                     </Link>
//                   </li>
//                   <li className="breadcrumb-item">Dashboard</li>
//                   <li className="breadcrumb-item"> Group Management</li>
//                   <li className="breadcrumb-item active" aria-current="page">
//                     Mange Sales Groups
//                   </li>
//                 </ol>
//               </nav>
//             </div>
//             <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
//             </div>
//           </div>

//           {/* Performance Indicator list */}
//           <div className="card">
//             <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
//               <h5>Group List </h5>


//               <Link
//                 to="#"
//                 className="btn btn-secondary d-flex align-items-center"
//                 data-bs-toggle="modal"
//                 data-bs-target="#createGroupModal"
//               >
//                 <i className="ti ti-circle-plus me-2" />
//                 Create Group
//               </Link>
//             </div>
//             <div className="card-body p-0">
//               {loading ? (
//                 <Loading />
//               ) : (
//                 <Table
//                   dataSource={allProperty}
//                   rowKeyId={"Staff_id"}
//                   columns={columns}
//                   Selection={false}
//                 />
//               )}
//             </div>
//           </div>
//           {/* /Performance Indicator list */}
//         </div>

//         {/* Create Group Modal */}
//  <div
//       className="modal fade"
//       id="createGroupModal"
//       tabIndex={-1}
//       aria-labelledby="createGroupModalLabel"
//       aria-hidden="true"
//     >
//       <div className="modal-dialog modal-dialog-centered">
//         <div className="modal-content">
//           <div className="modal-header">
//             <h5 className="modal-title" id="createGroupModalLabel">
//               Create New Group
//             </h5>
//             <button
//               type="button"
//               className="btn-close"
//               data-bs-dismiss="modal"
//               aria-label="Close"
//             ></button>
//           </div>

//           <div className="modal-body">
//             <form>
//               <div className="mb-3">
//                 <label className="form-label">Group Name</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   placeholder="Enter group name"
//                 />
//               </div>

//               <div className="mb-3">
//                 <label className="form-label">Description</label>
//                 <textarea
//                   className="form-control"
//                   rows={3}
//                   placeholder="Enter group description"
//                 ></textarea>
//               </div>

//        {/* Add Members */}
// {/* Add Members */}
// <div className="mb-3 position-relative">
//   <label className="form-label">Add Members</label>
//   <input
//     type="text"
//     className="form-control"
//     placeholder="Search and add members..."
//     value={search}
//     onChange={handleSearchChange}
//     onFocus={handleFocus}
//     onBlur={handleBlur}
//   />

// {(isFocused || search) && (
//   <div
//     className="position-absolute bg-white border rounded shadow-sm mt-1 w-100"
//     style={{
//       zIndex: 1000,
//       maxHeight: "300px",
//       overflowY: "auto",
//       overflowX: "hidden",
//       display: "block",
//     }}
//     onMouseDown={(e) => e.preventDefault()} // Prevent losing focus on click
//   >
//     <table
//       className="table table-sm mb-0 align-middle"
//       style={{
//         tableLayout: "fixed",
//         minWidth: "100%",
//       }}
//     >
//       <thead
//         className="table-light"
//         style={{
//           position: "sticky",
//           top: 0,
//           zIndex: 10,
//         }}
//       >
//         <tr>
//           <th style={{ width: "40px" }}>
//             <input
//               type="checkbox"
//               checked={
//                 filtered.length > 0 &&
//                 filtered.every((m) =>
//                   selected.some((s) => s.employee_id === m.employee_id)
//                 )
//               }
//               onChange={handleSelectAll}
//             />
//           </th>
//           <th style={{ width: "150px" }}>Employee ID</th>
//           <th>Name</th>
//           <th style={{ width: "150px" }}>Phone Number</th>
//         </tr>
//       </thead>
//       <tbody>
//         {filtered.length > 0 ? (
//           filtered.map((m) => {
//             const isChecked = selected.some(
//               (s) => s.employee_id === m.employee_id
//             );
//             return (
//               <tr
//                 key={m.employee_id}
//                 className={isChecked ? "table-primary" : ""}
//               >
//                 <td>
//                   <input
//                     type="checkbox"
//                     checked={isChecked}
//                     onChange={() => handleCheckboxSelect(m)}
//                   />
//                 </td>
//                 <td>{m.organization_user_id}</td>
//                 <td>{m.full_name}</td>
//                 <td>{m.mobile_no || "-"}</td>
//               </tr>
//             );
//           })
//         ) : (
//           <tr>
//             <td colSpan={4} className="text-center text-muted py-2">
//               No results found
//             </td>
//           </tr>
//         )}
//       </tbody>
//     </table>
//   </div>
// )}


//   {/* Selected members badges */}
//   <div className="mt-2 d-flex flex-wrap gap-2">
//     {selected.map((m) => (
//       <span
//         key={m.employee_id}
//         className="badge bg-primary d-flex align-items-center"
//       >
//         {m.full_name}
//         <button
//           type="button"
//           className="btn-close btn-close-white ms-2"
//           style={{ fontSize: "0.6rem" }}
//           onClick={() => handleRemove(m.employee_id)}
//         ></button>
//       </span>
//     ))}
//   </div>
// </div>


//             </form>
//           </div>

//           <div className="modal-footer d-flex gap-2">
//             <button
//               type="button"
//               className="btn btn-secondary"
//               data-bs-dismiss="modal"
//             >
//               Cancel
//             </button>
//             <button
//               type="button"
//               className="btn btn-primary"
//               data-bs-dismiss="modal"
//             >
//               Create Group
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>

//         {/*Footer*/}
//         <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
//           <p className="mb-0">
//             © {new Date().getFullYear()} Nestfin Technology. All rights
//             reserved.
//           </p>
//         </div>
//       </div>
//       {/* /Page Wrapper */}
//     </>
//   );
// };

// export default ManageSalesGroup;
